import { ContactSupportPayload } from '_api/types';

const DefaultContactSupportData: ContactSupportPayload = {
  message: '',
};

export default DefaultContactSupportData;
